/** Why an employment ended; mirrors the API's EMPLOYMENT_EXIT_TYPES. */
export const EXIT_TYPES = ['resigned', 'terminated', 'contract_ended', 'other'] as const
export type ExitType = (typeof EXIT_TYPES)[number]

export const EXIT_TYPE_LABELS: Record<ExitType, string> = {
  resigned: 'Resigned',
  terminated: 'Terminated',
  contract_ended: 'Contract ended',
  other: 'Other',
}

/** Exits recorded before exit types existed have none: "Not recorded". */
export function exitTypeLabel(value: string | null | undefined): string {
  if (!value) return 'Not recorded'
  return EXIT_TYPE_LABELS[value as ExitType] ?? value
}
